/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest =
  {
    organizationId: string;
    tenantId: string;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus =
  {
    AccountStatusUnspecified: "ACCOUNT_STATUS_UNSPECIFIED",
    AccountStatusActive: "ACCOUNT_STATUS_ACTIVE",
    AccountStatusSuspended: "ACCOUNT_STATUS_SUSPENDED",
    AccountStatusPendingVerification: "ACCOUNT_STATUS_PENDING_VERIFICATION",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles =
  {
    RoleUnspecified: "ROLE_UNSPECIFIED",
    RoleAdmin: "ROLE_ADMIN",
    RoleUser: "ROLE_USER",
    RoleViewer: "ROLE_VIEWER",
    RoleManager: "ROLE_MANAGER",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions =
  {
    PermissionUnspecified: "PERMISSION_UNSPECIFIED",
    PermissionRead: "PERMISSION_READ",
    PermissionWrite: "PERMISSION_WRITE",
    PermissionDelete: "PERMISSION_DELETE",
    PermissionManageUsers: "PERMISSION_MANAGE_USERS",
    PermissionManageBilling: "PERMISSION_MANAGE_BILLING",
    PermissionViewAnalytics: "PERMISSION_VIEW_ANALYTICS",
    PermissionManageWorkflows: "PERMISSION_MANAGE_WORKFLOWS",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone =
  {
    TimezoneUnspecified: "TIMEZONE_UNSPECIFIED",
    TimezoneUtc: "TIMEZONE_UTC",
    TimezoneEst: "TIMEZONE_EST",
    TimezoneCst: "TIMEZONE_CST",
    TimezoneMst: "TIMEZONE_MST",
    TimezonePst: "TIMEZONE_PST",
    TimezoneGmt: "TIMEZONE_GMT",
    TimezoneCet: "TIMEZONE_CET",
    TimezoneIst: "TIMEZONE_IST",
    TimezoneJst: "TIMEZONE_JST",
    TimezoneAest: "TIMEZONE_AEST",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: Date | undefined;
    lastRunTime?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status
      | undefined;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    jobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat
      | undefined;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours =
  {
    id?: string | undefined;
    day?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys =
  {
    id?: string | undefined;
    name?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    scopes?: Array<string> | undefined;
    allowedIps?: Array<string> | undefined;
    allowedDomains?: Array<string> | undefined;
    allowedEnvironments?: Array<string> | undefined;
    isTestKey?: boolean | undefined;
    requestsPerSecond?: number | undefined;
    requestsPerDay?: number | undefined;
    concurrentRequests?: number | undefined;
    monthlyRequestQuota?: string | undefined;
    costPerRequest?: number | undefined;
    billingTier?: string | undefined;
    totalRequests?: string | undefined;
    totalErrors?: string | undefined;
    lastUsedAt?: Date | undefined;
    averageResponseTime?: number | undefined;
    endpointUsageJson?: string | undefined;
    errorRatesJson?: string | undefined;
    recentErrors?: string | undefined;
    successfulRequestsCount?: number | undefined;
    successRate?: number | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus
      | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    expiresAt?: Date | undefined;
    deletedAt?: Date | undefined;
    lastRotatedAt?: Date | undefined;
    lastSecurityReviewAt?: Date | undefined;
    requiresClientSecret?: boolean | undefined;
    clientSecretHash?: string | undefined;
    enforceHttps?: boolean | undefined;
    enforceSigning?: boolean | undefined;
    allowedSignatureAlgorithms?: Array<string> | undefined;
    enforceMutualTls?: boolean | undefined;
    clientCertificateHash?: string | undefined;
    requireRequestSigning?: boolean | undefined;
    description?: string | undefined;
    metadataJson?: string | undefined;
    tags?: Array<string> | undefined;
    apiVersion?: string | undefined;
    supportedFeatures?: Array<string> | undefined;
    documentationUrl?: string | undefined;
    supportContact?: string | undefined;
    logAllRequests?: boolean | undefined;
    lastRotationReason?: string | undefined;
    lastRotationDate?: Date | undefined;
    rotationFrequencyDays?: number | undefined;
    complianceStandards?: Array<string> | undefined;
    requiresAuditLogging?: boolean | undefined;
    dataResidency?: string | undefined;
    approvedIntegrations?: Array<string> | undefined;
    alertEmails?: Array<string> | undefined;
    webhookUrl?: string | undefined;
    alertOnQuotaThreshold?: boolean | undefined;
    quotaAlertThreshold?: number | undefined;
    alertOnErrorSpike?: boolean | undefined;
    errorAlertThreshold?: number | undefined;
    monitoringIntegrations?: Array<string> | undefined;
    encrypted?: boolean | undefined;
    dataClassification?: string | undefined;
    maxUses?: number | undefined;
    rateLimit?: number | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents =
  {
    TriggerEventUnspecified: "TRIGGER_EVENT_UNSPECIFIED",
    TriggerEventJobStarted: "TRIGGER_EVENT_JOB_STARTED",
    TriggerEventJobCompleted: "TRIGGER_EVENT_JOB_COMPLETED",
    TriggerEventJobFailed: "TRIGGER_EVENT_JOB_FAILED",
    TriggerEventLeadFound: "TRIGGER_EVENT_LEAD_FOUND",
    TriggerEventQuotaExceeded: "TRIGGER_EVENT_QUOTA_EXCEEDED",
    TriggerEventErrorThresholdReached: "TRIGGER_EVENT_ERROR_THRESHOLD_REACHED",
    TriggerEventRateLimitReached: "TRIGGER_EVENT_RATE_LIMIT_REACHED",
    TriggerEventDataValidationFailed: "TRIGGER_EVENT_DATA_VALIDATION_FAILED",
    TriggerEventNewProxyNeeded: "TRIGGER_EVENT_NEW_PROXY_NEEDED",
    TriggerEventScheduledMaintenance: "TRIGGER_EVENT_SCHEDULED_MAINTENANCE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields =
  {
    IncludedFieldUnspecified: "INCLUDED_FIELD_UNSPECIFIED",
    IncludedFieldName: "INCLUDED_FIELD_NAME",
    IncludedFieldWebsite: "INCLUDED_FIELD_WEBSITE",
    IncludedFieldPhone: "INCLUDED_FIELD_PHONE",
    IncludedFieldAddress: "INCLUDED_FIELD_ADDRESS",
    IncludedFieldLocation: "INCLUDED_FIELD_LOCATION",
    IncludedFieldCoordinates: "INCLUDED_FIELD_COORDINATES",
    IncludedFieldGoogleRating: "INCLUDED_FIELD_GOOGLE_RATING",
    IncludedFieldReviewCount: "INCLUDED_FIELD_REVIEW_COUNT",
    IncludedFieldReviews: "INCLUDED_FIELD_REVIEWS",
    IncludedFieldBusinessHours: "INCLUDED_FIELD_BUSINESS_HOURS",
    IncludedFieldBusinessStatus: "INCLUDED_FIELD_BUSINESS_STATUS",
    IncludedFieldPlaceId: "INCLUDED_FIELD_PLACE_ID",
    IncludedFieldGoogleMapsUrl: "INCLUDED_FIELD_GOOGLE_MAPS_URL",
    IncludedFieldPhotos: "INCLUDED_FIELD_PHOTOS",
    IncludedFieldMainPhoto: "INCLUDED_FIELD_MAIN_PHOTO",
    IncludedFieldBusinessTypes: "INCLUDED_FIELD_BUSINESS_TYPES",
    IncludedFieldAmenities: "INCLUDED_FIELD_AMENITIES",
    IncludedFieldPaymentMethods: "INCLUDED_FIELD_PAYMENT_METHODS",
    IncludedFieldSocialProfiles: "INCLUDED_FIELD_SOCIAL_PROFILES",
    IncludedFieldEmployeeCount: "INCLUDED_FIELD_EMPLOYEE_COUNT",
    IncludedFieldRevenueInfo: "INCLUDED_FIELD_REVENUE_INFO",
    IncludedFieldFoundedYear: "INCLUDED_FIELD_FOUNDED_YEAR",
    IncludedFieldCertifications: "INCLUDED_FIELD_CERTIFICATIONS",
    IncludedFieldNaicsCode: "INCLUDED_FIELD_NAICS_CODE",
    IncludedFieldSicCode: "INCLUDED_FIELD_SIC_CODE",
    IncludedFieldScrapingMetadata: "INCLUDED_FIELD_SCRAPING_METADATA",
    IncludedFieldComplianceInfo: "INCLUDED_FIELD_COMPLIANCE_INFO",
    IncludedFieldAlternatePhones: "INCLUDED_FIELD_ALTERNATE_PHONES",
    IncludedFieldContactPerson: "INCLUDED_FIELD_CONTACT_PERSON",
    IncludedFieldContactEmail: "INCLUDED_FIELD_CONTACT_EMAIL",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat =
  {
    PayloadFormatUnspecified: "PAYLOAD_FORMAT_UNSPECIFIED",
    PayloadFormatJson: "PAYLOAD_FORMAT_JSON",
    PayloadFormatXml: "PAYLOAD_FORMAT_XML",
    PayloadFormatFormData: "PAYLOAD_FORMAT_FORM_DATA",
    PayloadFormatProtobuf: "PAYLOAD_FORMAT_PROTOBUF",
    PayloadFormatYaml: "PAYLOAD_FORMAT_YAML",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata =
  {};

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks =
  {
    id?: string | undefined;
    url?: string | undefined;
    authType?: string | undefined;
    authToken?: string | undefined;
    customHeaders?: { [k: string]: string } | undefined;
    maxRetries?: number | undefined;
    retryInterval?: string | undefined;
    triggerEvents?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents
      >
      | undefined;
    includedFields?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields
      >
      | undefined;
    includeFullResults?: boolean | undefined;
    payloadFormat?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat
      | undefined;
    verifySsl?: boolean | undefined;
    signingSecret?: string | undefined;
    rateLimit?: number | undefined;
    rateLimitInterval?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    lastTriggeredAt?: Date | undefined;
    successfulCalls?: number | undefined;
    failedCalls?: number | undefined;
    metadata?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata
      | undefined;
    webhookName?: string | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType =
  {
    WorkspaceTypeUnspecified: "WORKSPACE_TYPE_UNSPECIFIED",
    WorkspaceTypePersonal: "WORKSPACE_TYPE_PERSONAL",
    WorkspaceTypeTeam: "WORKSPACE_TYPE_TEAM",
    WorkspaceTypeEnterprise: "WORKSPACE_TYPE_ENTERPRISE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces =
  {
    id?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    domain?: string | undefined;
    gdprCompliant?: boolean | undefined;
    hipaaCompliant?: boolean | undefined;
    soc2Compliant?: boolean | undefined;
    storageQuota?: string | undefined;
    usedStorage?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    workflows?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows
      >
      | undefined;
    jobsRunThisMonth?: number | undefined;
    workspaceJobLimit?: number | undefined;
    dailyJobQuota?: number | undefined;
    activeScrapers?: number | undefined;
    totalLeadsCollected?: number | undefined;
    lastJobRun?: Date | undefined;
    scrapingJobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs
      >
      | undefined;
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys
      >
      | undefined;
    webhooks?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks
      >
      | undefined;
    workspaceType?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType
      | undefined;
    description?: string | undefined;
    metadata?: { [k: string]: string } | undefined;
    tags?: Array<string> | undefined;
    maxTeamMembers?: number | undefined;
    currentTeamMembers?: number | undefined;
    allowGuestAccess?: boolean | undefined;
    allowedEmailDomains?: Array<string> | undefined;
    exportFormats?: Array<string> | undefined;
    exportSchedule?: string | undefined;
    exportDestinations?: Array<string> | undefined;
    exportDestinationConfig?: { [k: string]: string } | undefined;
    compressExports?: boolean | undefined;
    compressionFormat?: string | undefined;
    salesforceEnabled?: boolean | undefined;
    salesforceConfig?: string | undefined;
    hubspotEnabled?: boolean | undefined;
    hubspotConfig?: string | undefined;
    zapierEnabled?: boolean | undefined;
    zapierWebhook?: string | undefined;
    activeIntegrations?: Array<string> | undefined;
    integrationSettings?: { [k: string]: string } | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings =
  {
    id?: string | undefined;
    emailNotifications?: boolean | undefined;
    slackNotifications?: boolean | undefined;
    defaultDataRetention?: string | undefined;
    autoPurgeEnabled?: boolean | undefined;
    require2fa?: boolean | undefined;
    sessionTimeout?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts =
  {
    id?: string | undefined;
    authPlatformUserId?: string | undefined;
    email?: string | undefined;
    deletedAt?: Date | undefined;
    createdAt?: Date | undefined;
    accountStatus?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus
      | undefined;
    roles?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles
      >
      | undefined;
    permissions?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions
      >
      | undefined;
    mfaEnabled?: boolean | undefined;
    lastLoginAt?: Date | undefined;
    timezone?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone
      | undefined;
    totalJobsRun?: number | undefined;
    monthlyJobLimit?: number | undefined;
    concurrentJobLimit?: number | undefined;
    workspaces?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces
      >
      | undefined;
    settings?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings
      | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus
  >;

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes =
  {
    TenantApiKeyScopeUnspecified: "TENANT_API_KEY_SCOPE_UNSPECIFIED",
    TenantApiKeyScopeReadJobs: "TENANT_API_KEY_SCOPE_READ_JOBS",
    TenantApiKeyScopeReadLeads: "TENANT_API_KEY_SCOPE_READ_LEADS",
    TenantApiKeyScopeReadWorkflows: "TENANT_API_KEY_SCOPE_READ_WORKFLOWS",
    TenantApiKeyScopeReadAnalytics: "TENANT_API_KEY_SCOPE_READ_ANALYTICS",
    TenantApiKeyScopeReadSettings: "TENANT_API_KEY_SCOPE_READ_SETTINGS",
    TenantApiKeyScopeWriteJobs: "TENANT_API_KEY_SCOPE_WRITE_JOBS",
    TenantApiKeyScopeWriteLeads: "TENANT_API_KEY_SCOPE_WRITE_LEADS",
    TenantApiKeyScopeWriteWorkflows: "TENANT_API_KEY_SCOPE_WRITE_WORKFLOWS",
    TenantApiKeyScopeWriteSettings: "TENANT_API_KEY_SCOPE_WRITE_SETTINGS",
    TenantApiKeyScopeDeleteJobs: "TENANT_API_KEY_SCOPE_DELETE_JOBS",
    TenantApiKeyScopeDeleteLeads: "TENANT_API_KEY_SCOPE_DELETE_LEADS",
    TenantApiKeyScopeDeleteWorkflows: "TENANT_API_KEY_SCOPE_DELETE_WORKFLOWS",
    TenantApiKeyScopeExportData: "TENANT_API_KEY_SCOPE_EXPORT_DATA",
    TenantApiKeyScopeManageKeys: "TENANT_API_KEY_SCOPE_MANAGE_KEYS",
    TenantApiKeyScopeBillingRead: "TENANT_API_KEY_SCOPE_BILLING_READ",
    TenantApiKeyScopeBillingWrite: "TENANT_API_KEY_SCOPE_BILLING_WRITE",
    TenantApiKeyScopeAdmin: "TENANT_API_KEY_SCOPE_ADMIN",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus
      | undefined;
    scopes?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes
      >
      | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: Date | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus =
  ClosedEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus
  >;

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant =
  {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    apiBaseUrl?: string | undefined;
    environmentVariables?: { [k: string]: string } | undefined;
    allowedOrigins?: Array<string> | undefined;
    storageQuota?: string | undefined;
    monthlyRequestLimit?: string | undefined;
    maxConcurrentJobs?: number | undefined;
    enableCaching?: boolean | undefined;
    enableRateLimiting?: boolean | undefined;
    enableRequestLogging?: boolean | undefined;
    accounts?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts
      >
      | undefined;
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys
      >
      | undefined;
    totalRequests?: string | undefined;
    totalStorageUsed?: string | undefined;
    averageResponseTime?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    status?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus
      | undefined;
  };

export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData =
  {
    tenant?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant
      | undefined;
  };

/**
 * Retrieves details of a specific tenant
 */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody =
  {
    data:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    organizationId: z.string(),
    tenantId: z.string(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$Outbound =
  {
    organizationId: string;
    tenantId: string;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest
  > = z.object({
    organizationId: z.string(),
    tenantId: z.string(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequestToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRequest' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHoursToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Day$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHoursToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviewsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeadsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONResponseBodyStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200Status$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflowsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflowsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHoursToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHoursToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviewsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeadsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponse200ApplicationJSONStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastRotatedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastSecurityReviewAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    scopes?: Array<string> | undefined;
    allowedIps?: Array<string> | undefined;
    allowedDomains?: Array<string> | undefined;
    allowedEnvironments?: Array<string> | undefined;
    isTestKey?: boolean | undefined;
    requestsPerSecond?: number | undefined;
    requestsPerDay?: number | undefined;
    concurrentRequests?: number | undefined;
    monthlyRequestQuota?: string | undefined;
    costPerRequest?: number | undefined;
    billingTier?: string | undefined;
    totalRequests?: string | undefined;
    totalErrors?: string | undefined;
    lastUsedAt?: string | undefined;
    averageResponseTime?: number | undefined;
    endpointUsageJson?: string | undefined;
    errorRatesJson?: string | undefined;
    recentErrors?: string | undefined;
    successfulRequestsCount?: number | undefined;
    successRate?: number | undefined;
    status: string;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    expiresAt?: string | undefined;
    deletedAt?: string | undefined;
    lastRotatedAt?: string | undefined;
    lastSecurityReviewAt?: string | undefined;
    requiresClientSecret?: boolean | undefined;
    clientSecretHash?: string | undefined;
    enforceHttps?: boolean | undefined;
    enforceSigning?: boolean | undefined;
    allowedSignatureAlgorithms?: Array<string> | undefined;
    enforceMutualTls?: boolean | undefined;
    clientCertificateHash?: string | undefined;
    requireRequestSigning?: boolean | undefined;
    description?: string | undefined;
    metadataJson?: string | undefined;
    tags?: Array<string> | undefined;
    apiVersion?: string | undefined;
    supportedFeatures?: Array<string> | undefined;
    documentationUrl?: string | undefined;
    supportContact?: string | undefined;
    logAllRequests?: boolean | undefined;
    lastRotationReason?: string | undefined;
    lastRotationDate?: string | undefined;
    rotationFrequencyDays?: number | undefined;
    complianceStandards?: Array<string> | undefined;
    requiresAuditLogging?: boolean | undefined;
    dataResidency?: string | undefined;
    approvedIntegrations?: Array<string> | undefined;
    alertEmails?: Array<string> | undefined;
    webhookUrl?: string | undefined;
    alertOnQuotaThreshold?: boolean | undefined;
    quotaAlertThreshold?: number | undefined;
    alertOnErrorSpike?: boolean | undefined;
    errorAlertThreshold?: number | undefined;
    monitoringIntegrations?: Array<string> | undefined;
    encrypted?: boolean | undefined;
    dataClassification?: string | undefined;
    maxUses?: number | undefined;
    rateLimit?: number | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.date().transform(v => v.toISOString()).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsResponseStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    lastRotatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastSecurityReviewAt: z.date().transform(v => v.toISOString()).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.date().transform(v => v.toISOString()).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeysToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata,
    z.ZodTypeDef,
    unknown
  > = z.object({});

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$Outbound =
  {};

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata
  > = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadataToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$inboundSchema,
    ).optional(),
    includedFields: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$inboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$inboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastTriggeredAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$inboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$Outbound =
  {
    id?: string | undefined;
    url?: string | undefined;
    authType?: string | undefined;
    authToken?: string | undefined;
    customHeaders?: { [k: string]: string } | undefined;
    maxRetries?: number | undefined;
    retryInterval?: string | undefined;
    triggerEvents?: Array<string> | undefined;
    includedFields?: Array<string> | undefined;
    includeFullResults?: boolean | undefined;
    payloadFormat: string;
    verifySsl?: boolean | undefined;
    signingSecret?: string | undefined;
    rateLimit?: number | undefined;
    rateLimitInterval?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    lastTriggeredAt?: string | undefined;
    successfulCalls?: number | undefined;
    failedCalls?: number | undefined;
    metadata?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$Outbound
      | undefined;
    webhookName?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTriggerEvents$outboundSchema,
    ).optional(),
    includedFields: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdIncludedFields$outboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPayloadFormat$outboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastTriggeredAt: z.date().transform(v => v.toISOString()).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdMetadata$outboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooksToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooksFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    workflows: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$inboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$inboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$inboundSchema
      ),
    ).optional(),
    workspaceType:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$inboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    domain?: string | undefined;
    gdprCompliant?: boolean | undefined;
    hipaaCompliant?: boolean | undefined;
    soc2Compliant?: boolean | undefined;
    storageQuota?: string | undefined;
    usedStorage?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    workflows?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$Outbound
      >
      | undefined;
    jobsRunThisMonth?: number | undefined;
    workspaceJobLimit?: number | undefined;
    dailyJobQuota?: number | undefined;
    activeScrapers?: number | undefined;
    totalLeadsCollected?: number | undefined;
    lastJobRun?: string | undefined;
    scrapingJobs?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$Outbound
      >
      | undefined;
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$Outbound
      >
      | undefined;
    webhooks?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$Outbound
      >
      | undefined;
    workspaceType: string;
    description?: string | undefined;
    metadata?: { [k: string]: string } | undefined;
    tags?: Array<string> | undefined;
    maxTeamMembers?: number | undefined;
    currentTeamMembers?: number | undefined;
    allowGuestAccess?: boolean | undefined;
    allowedEmailDomains?: Array<string> | undefined;
    exportFormats?: Array<string> | undefined;
    exportSchedule?: string | undefined;
    exportDestinations?: Array<string> | undefined;
    exportDestinationConfig?: { [k: string]: string } | undefined;
    compressExports?: boolean | undefined;
    compressionFormat?: string | undefined;
    salesforceEnabled?: boolean | undefined;
    salesforceConfig?: string | undefined;
    hubspotEnabled?: boolean | undefined;
    hubspotConfig?: string | undefined;
    zapierEnabled?: boolean | undefined;
    zapierWebhook?: string | undefined;
    activeIntegrations?: Array<string> | undefined;
    integrationSettings?: { [k: string]: string } | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    workflows: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkflows$outboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.date().transform(v => v.toISOString()).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScrapingJobs$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsApiKeys$outboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWebhooks$outboundSchema
      ),
    ).optional(),
    workspaceType:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaceType$outboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspacesToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspacesFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    emailNotifications: z.boolean().optional(),
    slackNotifications: z.boolean().optional(),
    defaultDataRetention: z.string().optional(),
    autoPurgeEnabled: z.boolean().optional(),
    require2fa: z.boolean().optional(),
    sessionTimeout: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$Outbound =
  {
    id?: string | undefined;
    emailNotifications?: boolean | undefined;
    slackNotifications?: boolean | undefined;
    defaultDataRetention?: string | undefined;
    autoPurgeEnabled?: boolean | undefined;
    require2fa?: boolean | undefined;
    sessionTimeout?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings
  > = z.object({
    id: z.string().optional(),
    emailNotifications: z.boolean().optional(),
    slackNotifications: z.boolean().optional(),
    defaultDataRetention: z.string().optional(),
    autoPurgeEnabled: z.boolean().optional(),
    require2fa: z.boolean().optional(),
    sessionTimeout: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettingsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettingsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    authPlatformUserId: z.string().optional(),
    email: z.string().optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    accountStatus:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$inboundSchema
        .default("ACCOUNT_STATUS_UNSPECIFIED"),
    roles: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$inboundSchema,
    ).optional(),
    permissions: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$inboundSchema,
    ).optional(),
    mfaEnabled: z.boolean().optional(),
    lastLoginAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    timezone:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$inboundSchema
        .default("TIMEZONE_UNSPECIFIED"),
    totalJobsRun: z.number().int().optional(),
    monthlyJobLimit: z.number().int().optional(),
    concurrentJobLimit: z.number().int().optional(),
    workspaces: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$inboundSchema
      ),
    ).optional(),
    settings: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$inboundSchema
    ).optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$Outbound =
  {
    id?: string | undefined;
    authPlatformUserId?: string | undefined;
    email?: string | undefined;
    deletedAt?: string | undefined;
    createdAt?: string | undefined;
    accountStatus: string;
    roles?: Array<string> | undefined;
    permissions?: Array<string> | undefined;
    mfaEnabled?: boolean | undefined;
    lastLoginAt?: string | undefined;
    timezone: string;
    totalJobsRun?: number | undefined;
    monthlyJobLimit?: number | undefined;
    concurrentJobLimit?: number | undefined;
    workspaces?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$Outbound
      >
      | undefined;
    settings?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$Outbound
      | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts
  > = z.object({
    id: z.string().optional(),
    authPlatformUserId: z.string().optional(),
    email: z.string().optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    accountStatus:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountStatus$outboundSchema
        .default("ACCOUNT_STATUS_UNSPECIFIED"),
    roles: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdRoles$outboundSchema,
    ).optional(),
    permissions: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdPermissions$outboundSchema,
    ).optional(),
    mfaEnabled: z.boolean().optional(),
    lastLoginAt: z.date().transform(v => v.toISOString()).optional(),
    timezone:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTimezone$outboundSchema
        .default("TIMEZONE_UNSPECIFIED"),
    totalJobsRun: z.number().int().optional(),
    monthlyJobLimit: z.number().int().optional(),
    concurrentJobLimit: z.number().int().optional(),
    workspaces: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdWorkspaces$outboundSchema
      ),
    ).optional(),
    settings: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdSettings$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountsToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccountsFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$inboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$Outbound =
  {
    id?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    status: string;
    scopes?: Array<string> | undefined;
    maxUses?: number | undefined;
    allowedIps?: Array<string> | undefined;
    useCount?: number | undefined;
    expiresAt?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys
  > = z.object({
    id: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantsStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    scopes: z.array(
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdScopes$outboundSchema,
    ).optional(),
    maxUses: z.number().int().optional(),
    allowedIps: z.array(z.string()).optional(),
    useCount: z.number().int().optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeysToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus
  > = z.nativeEnum(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus,
  );

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus
  > =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$outboundSchema;
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    description: z.string().optional(),
    apiBaseUrl: z.string().optional(),
    environmentVariables: z.record(z.string()).optional(),
    allowedOrigins: z.array(z.string()).optional(),
    storageQuota: z.string().optional(),
    monthlyRequestLimit: z.string().optional(),
    maxConcurrentJobs: z.number().int().optional(),
    enableCaching: z.boolean().optional(),
    enableRateLimiting: z.boolean().optional(),
    enableRequestLogging: z.boolean().optional(),
    accounts: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$inboundSchema
      ),
    ).optional(),
    totalRequests: z.string().optional(),
    totalStorageUsed: z.string().optional(),
    averageResponseTime: z.number().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    displayName?: string | undefined;
    description?: string | undefined;
    apiBaseUrl?: string | undefined;
    environmentVariables?: { [k: string]: string } | undefined;
    allowedOrigins?: Array<string> | undefined;
    storageQuota?: string | undefined;
    monthlyRequestLimit?: string | undefined;
    maxConcurrentJobs?: number | undefined;
    enableCaching?: boolean | undefined;
    enableRateLimiting?: boolean | undefined;
    enableRequestLogging?: boolean | undefined;
    accounts?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$Outbound
      >
      | undefined;
    apiKeys?:
      | Array<
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$Outbound
      >
      | undefined;
    totalRequests?: string | undefined;
    totalStorageUsed?: string | undefined;
    averageResponseTime?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    status: string;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    description: z.string().optional(),
    apiBaseUrl: z.string().optional(),
    environmentVariables: z.record(z.string()).optional(),
    allowedOrigins: z.array(z.string()).optional(),
    storageQuota: z.string().optional(),
    monthlyRequestLimit: z.string().optional(),
    maxConcurrentJobs: z.number().int().optional(),
    enableCaching: z.boolean().optional(),
    enableRateLimiting: z.boolean().optional(),
    enableRequestLogging: z.boolean().optional(),
    accounts: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdAccounts$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdApiKeys$outboundSchema
      ),
    ).optional(),
    totalRequests: z.string().optional(),
    totalStorageUsed: z.string().optional(),
    averageResponseTime: z.number().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenantFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData,
    z.ZodTypeDef,
    unknown
  > = z.object({
    tenant: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$inboundSchema
    ).optional(),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$Outbound =
  {
    tenant?:
      | GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$Outbound
      | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData
  > = z.object({
    tenant: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdTenant$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDataToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdDataFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData' from JSON`,
  );
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$inboundSchema
    ),
  });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$Outbound =
  {
    data:
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$Outbound;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody
  > = z.object({
    data: z.lazy(() =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdData$outboundSchema
    ),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$Outbound;
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBodyToJSON(
  getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody:
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody,
): string {
  return JSON.stringify(
    GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$outboundSchema
      .parse(
        getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody,
      ),
  );
}

export function getApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetApiLeadScraperMicroserviceApiV1OrganizationsTenantsOrganizationIdTenantIdResponseBody' from JSON`,
  );
}
